import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { WooTableColumn } from '@src/shared/presentational/woo-table/woo-table-column/woo-table-column.component';
import { WooTableComponent } from '@src/shared/presentational/woo-table/woo-table.component';
import { OmsInventoryNoticeComponent } from '../../src/shared/feedback/oms-inventory-notice/oms-inventory-notice.component';
import { DotLoader } from '../../src/shared/feedback/loader/dot-loader.component';
import { WooTabComponent } from '../../src/shared/navigation/woo-tabs/woo-tab/woo-tab.component';
import { WooTabsComponent } from '../../src/shared/navigation/woo-tabs/woo-tabs.component';
import { Inventory } from './components/inventory/inventory.component';
import { InventoryReports } from './components/inventory_reports/inventory-reports.compontent';
import { InventoryView } from './components/inventory_view/inventory-view.component';
import { InventoryWeeksPicker } from './components/inventory_weeks_picker/inventory-weeks-picker.compontent';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OmsInventoryNoticeComponent,
    WooTabsComponent,
    WooTabComponent,
    InventoryWeeksPicker,
    DotLoader,
    WooTableComponent,
    WooTableColumn,
    WooComponentsModule,
  ],
  providers: [],
  declarations: [InventoryReports, InventoryView, Inventory],
  exports: [Inventory],
})
export class WooInventoryModule {}
